<div class="alturaTabs row">
  <div class="offset-1 col-10 offset-md-3 col-md-6" style="padding-top: 3rem;">
    <div class="well well2" style="border: none; box-shadow: none;">
      <ng-container *ngFor="let cambioRealizado of changesMade">
        <h4 *ngIf="cambioRealizado.type !== change.type" [innerHtml]="cambioRealizado.htmlInstead"></h4>
      </ng-container>
    </div>

    <form #frm="ngForm" (ngSubmit)="confirm(frm);"  class="form">
      <div class="custom-checkbox" style="padding-bottom:20px;">
        <input type="checkbox" id="cb1" name="janitorDelivery" [(ngModel)]="change.janitorDelivery"  >
        <label for="cb1" style="padding-left:40px;">{{'ModifyDelivery.DeliveryConcierge' | translate}}</label>
      </div>
      <div class="form-group formNeighbor" *ngIf="!change.janitorDelivery">
        <label [ngClass]="{'deshabilitado': change.janitorDelivery}" style="margin: 0">
          {{'ModifyDelivery.NameInput' | translate}}
          <input type="text" [disabled]="change.janitorDelivery" class="form-control"  [focus]="active"  name="change.name" [(ngModel)]="change.janitorDelivery ? '' : change.name"  required maxlength="20">
        </label>
      </div>
      <div  class="form-group formNeighbor" *ngIf="!change.janitorDelivery">
        <label [ngClass]="{'deshabilitado': change.janitorDelivery}" style="margin: 0">
          {{'ModifyDelivery.AddressInput' | translate}}
          <i class="bi bi-info-circle-fill" [tooltip]="'ModifyDelivery.AddressInfo' | translate" placement="auto"></i>
          <span *ngIf="!change.direction"><br/>{{'ModifyDelivery.AddressWarning' | translate}}</span>
          <input type="text" [textoEtiqueta]="'ModifyDelivery.AddressInput' | translate" class="form-control" [disabled]="change.janitorDelivery"  name="change.direction" [(ngModel)]="change.janitorDelivery ? '' : change.direction"  maxlength="40" required>
        </label>
      </div>
      <div class="form-group formNeighbor">
        <label>
          {{'ModifyDelivery.InputInfo' | translate}}
          <textarea type="text" class="form-control" name="change.observations" style="line-height: normal; resize: none" [(ngModel)]="change.additionalInformation"  [maxlength]="change.janitorDelivery ? (80 - ('ModificarEnvio.CheckConserje' | translate).length) : (80 - change.name.length - change.direction.length)"></textarea>
        </label>
      </div>
      <div class="row">
      <div class="col-12 offset-lg-3 offset-md-4 col-md-8  col-lg-6 formLocalice btnSentStatus d-grid">
        <button
        type="submit"
        class="btn btn-default btn-block"
        style="width: auto;">
        {{'ModifyDelivery.ConfirmChangesButton' | translate}}
      </button>
      </div>

      </div>
    </form>
  </div>
</div>
